import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getEquiposRadiologicos, getSustancias, getUnidadesDeMedida } from "../../../../../../redux/actions/resolucion";
import CircularLoading from "../../../../../commons/loading/CircularLoading";
import { StyledResolucion } from "../../../../../styled/Prevencion";
import DatosSustanciaContainer from "./part1/DatosSustanciaContainer";

const SustanciasFormContainer = ({
  handleCancelSustancia,
  submitSustancia,
  idDependenciaEmpleador,
}) => {
  const dispatch = useDispatch();

  const sustancias = useSelector((state) => state.resolucion.sustancias);
  const sustancia = useSelector((state) => state.resolucion.abmSustancia);
  const unidadDeMedida = useSelector(
    (state) => state.resolucion.unidadDeMedida
  );

  const handleSustanciaFinalSubmit = (values) => {
    const { idTabla, ...submitData } = sustancia;

    // Encontrar el objeto sustancia completo desde la lista
    const sustanciaCompleta = sustancias.data.find((s) => s.id === values.sustancia);

    // Validar si la sustancia requiere equipos radiológicos
    const sustanciasQueRequierenEquipos = [
      "Radiaciones ionizantes",
      "Radiación neutrónica",
      "Rayos X y Radiación Gamma"
    ];

    if (sustanciaCompleta) {
      const nombreSustancia = sustanciaCompleta.nombre || "";
      const requiereEquipos = sustanciasQueRequierenEquipos.some(
        (nombreRequerido) => nombreSustancia.toLowerCase().includes(nombreRequerido.toLowerCase())
      );

      if (requiereEquipos && (!sustancia.equiposRadiologicos || sustancia.equiposRadiologicos.length === 0)) {
        toast.error("Se debe cargar al menos un equipo radiológico para esta sustancia");
        return;
      }
    }

    submitSustancia({
      ...submitData,
      sustancia: sustanciaCompleta ? {
        sustancia: sustanciaCompleta.id,  // ID del agente cancerígeno
        nombre: values.nombre,  // Nombre comercial ingresado por el usuario
        nombreAgente: sustanciaCompleta.nombre.split(" - ")[0],
        descripcionAgente: sustanciaCompleta.nombre.split(" - ")[1],
        cantidad: values.cantidad || "",
        unidad: values.unidad || null,
      } : null,
    }, idTabla);
  };

  useEffect(() => {
    // Load sustancias
    dispatch(getSustancias());
    // Load unidad de medida
    dispatch(getUnidadesDeMedida());
    // Load Equipo radiologico
    dispatch(getEquiposRadiologicos(idDependenciaEmpleador));
  }, [dispatch, idDependenciaEmpleador]);

  if (sustancias.loading || unidadDeMedida.loading) {
    return (
      <StyledResolucion.LoadingContainer>
        {" "}
        <CircularLoading />{" "}
      </StyledResolucion.LoadingContainer>
    );
  }

  return (
    <>
      <DatosSustanciaContainer
        handleSubmit={handleSustanciaFinalSubmit}
        handleCancelSustancia={handleCancelSustancia}
      />
    </>
  );
};

export default SustanciasFormContainer;
